import { render, staticRenderFns } from "./display-field-score.vue?vue&type=template&id=76af3a65&scoped=true&"
import script from "./display-field-score.vue?vue&type=script&lang=ts&"
export * from "./display-field-score.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76af3a65",
  null
  
)

export default component.exports